/* eslint-disable eol-last */


const app = {};

function recursifMenus(list, rows) {
    list.forEach((row) => {
        if (row.judul=='Y') {
            // const menus = rows.filter(r => (r.kode.startsWith(row.kode) && (r.kode.localeCompare(row.kode)==1)));
            const menus = rows.filter(r => (r.kode.startsWith(row.kode) && (r.kode.localeCompare(row.kode) == 1) && (r.level==row.level+1)));
            if (menus.length > 0) {
                row.children = menus;
                // row.children = menus.sort((a, b) => a.kode.localeCompare(b.kode));
                recursifMenus(menus, rows);
            }
        }
    });
}

app.list = (rows) => {
    const list = rows.filter(r => r.level === 1);
    recursifMenus(list, rows);
    return list;
};

export default app;
// module.exports = app;